import { FormApiContext } from '../utils';

export const areCouponsAvailableForService = async ({
  couponsServer,
  authorization,
}: FormApiContext): Promise<boolean> => {
  try {
    const { hasCoupons } = await couponsServer
      .CouponsV2()({ Authorization: authorization })
      .hasCoupons({});
    return hasCoupons;
  } catch (e) {
    console.error('Error checking coupons availability', (e as any).message);
    return false;
  }
};
